import { includes, isEmpty, isObjectLike } from 'lodash';

import { CASH_PURCHASE_ONLY_DISCOUNT } from 'commons-vehicle/constants/dataConversions.js';

import * as dataTypes from 'commons-vehicle/constants/dataTypes.js';
import OptionModel from 'commons-vehicle/ModelYear/models/OptionModel.js';
/* eslint import/prefer-default-export: 0 no-bitwise: 0 */

function convertOptionFlags(option) {
    return {
        enabled: (option.flag & dataTypes.ITEM_FLAG.AVAILABLE) > 0,
        selected: (option.flag & dataTypes.ITEM_FLAG.SELECTED) > 0,
        isConfigurationOption: (option.flag & dataTypes.ITEM_FLAG.CONFIGURATION_SELECTED) > 0,
        isTaxable:
            (option.flag & (dataTypes.ITEM_FLAG.NON_TAXABLE_FEDERAL | dataTypes.ITEM_FLAG.NON_TAXABLE_PROVINCIAL)) ===
            0,
        dueAtDelivery: option.priceInclusion ? option.priceInclusion.epi === 0 : false,
    };
}

export function resetOptionFromOptionData(optionData) {
    if (isEmpty(optionData) || !isObjectLike(optionData)) {
        return new OptionModel();
    }

    const { enabled, selected, isConfigurationOption, isTaxable, dueAtDelivery } = convertOptionFlags(optionData);

    return new OptionModel({
        selectionCode: `${optionData.code}>${optionData.supplier}`,
        enabled,
        visible: true,
        selected,
        isConfigurationOption,
        dueAtDelivery,
        userSelected: false,
        code: optionData.code,
        parentCode: optionData.parentCode,
        description: optionData.description,
        dataType: optionData.dataType,
        typeID: optionData.typeID,
        supplier: optionData.supplier,
        flag: optionData.flag,
        residualizingAmount: optionData.residualizingAmount,
        retail: optionData.retail,
        isTaxable,
    });
}

export function resetOptionFromQuoteItem(quoteItem, isIncludedInPriceOrPayment) {
    if (isEmpty(quoteItem) || !isObjectLike(quoteItem)) {
        return new OptionModel();
    }

    const { enabled, selected, isConfigurationOption, isTaxable, dueAtDelivery } = convertOptionFlags(quoteItem);
    const hasDealerCashOnlyDiscount = includes(quoteItem.supplierCodes, CASH_PURCHASE_ONLY_DISCOUNT);

    return new OptionModel({
        selectionCode: `${quoteItem.code}>${quoteItem.supplier}`,
        enabled,
        visible: true,
        selected: selected || hasDealerCashOnlyDiscount,
        isConfigurationOption,
        dueAtDelivery,
        userSelected: false,
        code: quoteItem.code,
        description: isEmpty(quoteItem.description) ? '' : quoteItem.description.descriptions[0],
        dataType: quoteItem.dataType,
        typeID: quoteItem.typeID,
        supplier: quoteItem.supplier,
        supplierCodes: quoteItem.supplierCodes,
        flag: quoteItem.flag,
        residualizingAmount: quoteItem.amounts.residualizingAmount,
        retail: quoteItem.amounts.retail,
        isTaxable,
        isIncludedInPriceOrPayment: isIncludedInPriceOrPayment || false,
    });
}

export function resetOptionFromProtectionItem(protectionItem) {
    if (isEmpty(protectionItem) || !isObjectLike(protectionItem)) {
        return new OptionModel();
    }

    const {
        dataType,
        typeID,
        categoryID,
        flag,
        code,
        parentCode,
        keyOrder,
        includedCodes,
        supplier,
        supplierCodes,
        description,
        amounts,
        imageUrl,
        webUrl,
        htmlTag,
        isPopular,
        isDealerInstalled,
        identificationType,
        parentIdentificationType,
        protectionCoverage,
    } = protectionItem;

    const { enabled, selected, isConfigurationOption, isTaxable, dueAtDelivery } = convertOptionFlags(protectionItem);
    const optionDesc =
        !isEmpty(description) && !isEmpty(description.description) ? description.description : description;

    return new OptionModel({
        selectionCode: `${code}>${supplier}`,
        enabled,
        selected,
        isConfigurationOption,
        dueAtDelivery,
        code,
        parentCode: !isEmpty(parentCode) ? parentCode : '',
        keyOrder,
        includedCodes,
        label: isEmpty(optionDesc) ? '' : optionDesc.labels[0],
        description: isEmpty(optionDesc) ? '' : optionDesc.descriptions[0],
        note: isEmpty(optionDesc) ? '' : optionDesc.notes[0],
        dataType,
        typeID,
        typeDescription: !isEmpty(identificationType) ? identificationType.description.descriptions[0] : '',
        typeNote: !isEmpty(identificationType) ? identificationType.description.notes[0] : '',
        parentTypeID: !isEmpty(parentIdentificationType) ? parentIdentificationType.typeID : null,
        parentTypeDescription: !isEmpty(parentIdentificationType)
            ? parentIdentificationType.description.descriptions[0]
            : '',
        parentTypeNote: !isEmpty(parentIdentificationType) ? parentIdentificationType.description.notes[0] : '',
        categoryID,
        supplier,
        supplierCodes,
        flag,
        residualizingAmount: amounts.residualizingAmount,
        retail: amounts.retail,
        isTaxable,
        imageUrl: isEmpty(imageUrl) ? '' : imageUrl[0],
        webUrl: isEmpty(webUrl) ? '' : webUrl[0],
        htmlBlock: isEmpty(htmlTag) ? '' : htmlTag[0],
        mostPopular: isPopular,
        isGroup: !isEmpty(identificationType) ? identificationType.isGroup : false,
        isInstalledAtDealership: isDealerInstalled,
        protectionCoverage: !isEmpty(protectionCoverage) ? protectionCoverage : null,
    });
}

export default {
    resetOptionFromOptionData,
    resetOptionFromQuoteItem,
    resetOptionFromProtectionItem,
};



// WEBPACK FOOTER //
// ./src/ModelYear/services/OptionService/OptionService.js